import React, { memo } from "react";
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";
import PaymentFailureContent from "./PaymentFailureContent";
import { IPaymentFailureConfirmationProps } from "./types";

const PaymentFailureConfirmation = memo(
    ({
        show,
        amount,
        onClose,
        onTryOtherMethods,
        paymentFailureCardData,
    }: IPaymentFailureConfirmationProps) => {
        return (
            <HalfCard
                isOpen={show}
                hasCustomPadding={true}
                hideCloseIcon={false}
                closeOnOverlayClick={true}
                onClose={onClose}
            >
                <PaymentFailureContent
                    amount={amount}
                    onTryOtherMethods={onTryOtherMethods}
                    paymentFailureCardData={paymentFailureCardData}
                />
            </HalfCard>
        );
    }
);

PaymentFailureConfirmation.displayName = "PaymentFailureConfirmation";

export default PaymentFailureConfirmation;
